export const SET_HRES6JU_INDEX_DISP = 'SET_HRES6JU_INDEX_DISP'
export const GET_HRES6JU_INDEX_DISP = 'GET_HRES6JU_INDEX_DISP'
export const SET_HRES6JU_DETAIL_DISP = 'SET_HRES6JU_DETAIL_DISP'
export const GET_HRES6JU_DETAIL_DISP = 'GET_HRES6JU_DETAIL_DISP'
export const GET_HRES6JU_MAX_ROWSPAN = 'GET_HRES6JU_MAX_ROWSPAN'
export const SET_HRES6JU_COLUMNS = 'SET_HRES6JU_COLUMNS'
export const GET_HRES6JU_COLUMNS = 'GET_HRES6JU_COLUMNS'
export const SET_HRES6JU_LABELS = 'SET_HRES6JU_LABELS'
export const GET_HRES6JU_LABELS = 'GET_HRES6JU_LABELS'
export const RECEIVED_HRES6JU_COLUMNS_LABELS = 'RECEIVED_HRES6JU_COLUMNS_LABELS'
export const SET_HRES6JU_INDEX = 'SET_HRES6JU_INDEX'
export const GET_HRES6JU_INDEX = 'GET_HRES6JU_INDEX'
export const RECEIVED_HRES6JU_INDEX = 'RECEIVED_HRES6JU_INDEX'
export const SET_HRES6JU_INDEX_SELECTED = 'SET_HRES6JU_INDEX_SELECTED'
export const GET_HRES6JU_INDEX_SELECTED = 'GET_HRES6JU_INDEX_SELECTED'
export const SET_HRES6JU_DETAIL = 'SET_HRES6JU_DETAIL'
export const GET_HRES6JU_DETAIL = 'GET_HRES6JU_DETAIL'
export const RECEIVED_HRES6JU_DETAIL = 'RECEIVED_HRES6JU_DETAIL'
export const SET_HRES6JU_DETAIL_POPUP = 'SET_HRES6JU_DETAIL_POPUP'
export const GET_HRES6JU_DETAIL_POPUP = 'GET_HRES6JU_DETAIL_POPUP'
export const RECEIVED_HRES6JU_DETAIL_POPUP = 'RECEIVED_HRES6JU_DETAIL_POPUP'
export const TOGGLE_HRES6JU_PAGE = 'TOGGLE_HRES6JU_PAGE'
export const POST_HRES6JU_SEND_APPROVE = 'POST_HRES6JU_SEND_APPROVE'
export const RECEIVED_HRES6JU_DROPDOWNS = 'RECEIVED_HRES6JU_DROPDOWNS'
export const SET_HRES6JU_DROPDOWNS = 'SET_HRES6JU_DROPDOWNS'
export const GET_HRES6JU_DROPDOWNS = 'GET_HRES6JU_DROPDOWNS'
export const RECEIVED_HRES6JU_TRAINING = 'RECEIVED_HRES6JU_TRAINING'
export const SET_HRES6JU_TRAINING = 'SET_HRES6JU_TRAINING'
export const GET_HRES6JU_TRAINING = 'GET_HRES6JU_TRAINING'

export const SET_HRES6JU_DETAIL_SUBMIT = 'SET_HRES6JU_DETAIL_SUBMIT'
export const GET_HRES6JU_DETAIL_SUBMIT = 'GET_HRES6JU_DETAIL_SUBMIT'
export const RECEIVED_HRES6JU_DETAIL_SUBMIT = 'RECEIVED_HRES6JU_DETAIL_SUBMIT'

export const SET_HRES6JU_COURSE_DETAIL = 'SET_HRES6JU_COURSE_DETAIL'
export const GET_HRES6JU_COURSE_DETAIL = 'GET_HRES6JU_COURSE_DETAIL'
export const RECEIVED_HRES6JU_COURSE_DETAIL = 'RECEIVED_HRES6JU_COURSE_DETAIL'

export const SET_HRES6JU_NUMCLSEQ = 'SET_HRES6JU_NUMCLSEQ'
export const RECEIVED_HRES6JU_NUMCLSEQ = 'RECEIVED_HRES6JU_NUMCLSEQ'



// WEBPACK FOOTER //
// ./src/store/modules/hres6ju/mutation-types.js